import { z } from 'zod';

/**
 * Catálogo de `animacion_base`, el único dato de contexto que sigue en el
 * wire hacia este cliente: viaja en `payload.avatar` del backchannel del
 * paciente (JC §4). El turno del paciente (JC §3) ya no trae objeto
 * `avatar`, así que `emocion` y `estado_fisico` salieron del cliente.
 *
 * Se recibe y se valida; **no se renderiza** (el rig no tiene canal
 * corporal). Schema laxo (P3) + narrowing opcional.
 *
 * Fuente del catálogo: JC §9, 8c.
 */
export const ANIMACIONES_BASE = [
  'sentado_normal',
  'sentado_incomodo',
  'sentado_agitado',
  'tos',
  'llanto',
  'risa',
  'bostezo',
  'grimace_dolor',
  'evasivo_mirada',
  'cooperativo_inclinado',
] as const;
export type AnimacionBaseConocida = (typeof ANIMACIONES_BASE)[number];
export function isAnimacionBaseConocida(value: string): value is AnimacionBaseConocida {
  return (ANIMACIONES_BASE as readonly string[]).includes(value);
}
export const AnimacionBaseSchema = z.string();
